import { jsx as _jsx } from "react/jsx-runtime";
import { StyledButton } from './Button.styles';
export const Button = ({ type = 'button', size = 'm', buttonTheme = 'blue', className, children, ...props }) => {
    return (_jsx(StyledButton, { type: type, "$size": size, "$buttonTheme": buttonTheme, className: className, ...props, children: children }));
};
//# sourceMappingURL=Button.js.map